import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { KeyRoleApi } from '../api/keyrole.api';
import { switchMap, map } from 'rxjs/operators';
import { KeyRoleData, KeyRole } from '../../../interfaces/masters/keyrole' ;
@Injectable()
export class KeyRoleService extends KeyRoleData {

    constructor(private api: KeyRoleApi) {
      super();
    }
  
  
    list(url: string): Observable<KeyRole[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<KeyRole>{
        return this.api.getById(url);
    }
  
    create(url: string, data:KeyRole): Observable<KeyRole[]> {
      debugger;
      return this.api.add(url,data);
    }
  
    update(url: string, data:KeyRole): Observable<KeyRole> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  